import { IonButton, IonButtons, IonContent, IonDatetime, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonPage, IonPopover, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform, useIonViewDidEnter } from '@ionic/react';
import dayjs from 'dayjs';
import { arrowBack } from 'ionicons/icons';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useContext, useRef, useState } from 'react';
import { CSVLink } from "react-csv";
import { useHistory } from 'react-router-dom';
import { fiscalRelatorioNFCe } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import FiscalTable from './FiscalTable';
import './RelatorioFiscal.css';

type Props = {
  abrirMenu: boolean;
}

const RelatorioFiscal: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [lojaSelecionadaId, setLojaSelecionadaId] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaId || "");
  const [lojaSelecionadaNome, setLojaSelecionadaNome] = useState<string>(JSON.parse(window.localStorage.getItem("lojas") || "[]")[0]?.empresaLojaNome || "");

  const [stateCupons, setStateCupons] = useState<any>([]);
  const [stateTotalCfop, setStateTotalCfop] = useState<any>([]);
  const [stateTotalPeriodo, setStateTotalPeriodo] = useState<any>([]);
  const [stateCarregado, setStateCarregado] = useState<boolean>(false);
  const [stateCsvData, setStateCsvData] = useState<any>([]);

  const popover1 = useRef<HTMLIonPopoverElement>(null);
  const popover2 = useRef<HTMLIonPopoverElement>(null);

  const [showModalDataInicio, setShowModalDataInicio] = useState(false);
  const [showModalDataFim, setShowModalDataFim] = useState(false);

  const [dataAgendamentoPeriodo1, setDataAgendamentoPeriodo1] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo1Br, setDataAgendamentoPeriodo1Br] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2, setDataAgendamentoPeriodo2] = useState<any>("Selecione");
  const [dataAgendamentoPeriodo2Br, setDataAgendamentoPeriodo2Br] = useState<any>("Selecione");

  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
  });

  function formatarValor(valor: number): string {
    return valor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function formatarData(dataStr: string): string {
    if (!dataStr) return '-';
    return dayjs(dataStr).format('DD/MM/YYYY');
  }

  function formatarCpfCnpj(doc: string): string {
    if (!doc) return '-';
    if (doc.length === 11) {
      return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (doc.length === 14) {
      return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return doc;
  }

  async function carregarDados(exportFunction?: any) {
    if (dataAgendamentoPeriodo1Br === "Selecione" || dataAgendamentoPeriodo2Br === "Selecione") {
      setTextToast("Todos os campos são obrigatórios.");
      setShowToast(true);
      return;
    }

    let data1 = new Date(dataAgendamentoPeriodo1).getTime();
    let data2 = new Date(dataAgendamentoPeriodo2).getTime();

    var msDiff = data2 - data1;
    var msDiffDay = Math.floor(msDiff / (1000 * 60 * 60 * 24));

    if (msDiffDay < 0) {
      setTextToast("Data fim não pode ser menor que Data início.");
      setShowToast(true);
      return;
    }
    else if (msDiffDay > 31) {
      setTextToast("Intervalo da data não pode ser maior que 31 dias.");
      setShowToast(true);
      return;
    }

    setStateCarregado(true);
    setShowLoading(true);

    try {
      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let dataFormatada = dayjs(dataAgendamentoPeriodo1).format('YYYY-MM-DD');
      let dataFormatada2 = dayjs(dataAgendamentoPeriodo2).format('YYYY-MM-DD');

      let urlFinal = fiscalRelatorioNFCe.url.replace('{empresaId}', encodeURIComponent(lojaSelecionadaId))
        + "?dataInicio=" + dataFormatada
        + "&dataFim=" + dataFormatada2;

      const resp: Response = await fetch(urlFinal, {
        method: fiscalRelatorioNFCe.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });

      let res = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
        return;
      }

      if (res && res.sucesso && res.dados) {
        const cuponsRaw = res.dados;

        // ===========================================
        // TABELA 1: Cupons Emitidos
        // ===========================================
        let arrayCupons: any[] = [];
        arrayCupons.push(['Número', 'Série', 'Modelo', 'Emissão', 'Empresa', 'CPF/CNPJ', 'CFOP', 'CSOSN', 'Valor Total']);

        cuponsRaw.forEach((cupom: any) => {
          arrayCupons.push([
            cupom.numero,
            cupom.serie,
            cupom.modelo === 65 ? '65 (NFC-e)' : cupom.modelo,
            formatarData(cupom.emissao),
            cupom.nome || '-',
            formatarCpfCnpj(cupom.cpfCnpj),
            cupom.cfop || '-',
            cupom.csosn || '-',
            'R$ ' + formatarValor(cupom.valorTotal || 0)
          ]);
        });

        setStateCupons(arrayCupons);

        // ===========================================
        // TABELA 2: Total Geral por CFOP
        // ===========================================
        const mapCfop: any = {};
        cuponsRaw.forEach((cupom: any) => {
          const cfop = cupom.cfop || 'N/A';
          if (!mapCfop[cfop]) {
            mapCfop[cfop] = { quantidade: 0, valorTotal: 0 };
          }
          mapCfop[cfop].quantidade += 1;
          mapCfop[cfop].valorTotal += (cupom.valorTotal || 0);
        });

        let arrayTotalCfop: any[] = [];
        arrayTotalCfop.push(['CFOP', 'Quant.', 'Valor Total']);
        Object.keys(mapCfop).sort().forEach((cfop: string) => {
          arrayTotalCfop.push([
            cfop,
            mapCfop[cfop].quantidade,
            'R$ ' + formatarValor(mapCfop[cfop].valorTotal)
          ]);
        });

        setStateTotalCfop(arrayTotalCfop);

        // ===========================================
        // TABELA 3: Total do Período
        // ===========================================
        // Agrupa por status contando NFC-es únicas (por número+série)
        const mapPeriodo: any = {};
        const nfcesUnicas: any = {};

        cuponsRaw.forEach((cupom: any) => {
          const situacao = cupom.status === 'CANCELADA' ? 'Cancelada' : 'Autorizada';
          const chaveNfce = `${cupom.numero}#${cupom.serie}`;

          if (!mapPeriodo[situacao]) {
            mapPeriodo[situacao] = { quantidade: 0, valorTotal: 0, nfces: new Set() };
          }
          if (!mapPeriodo[situacao].nfces.has(chaveNfce)) {
            mapPeriodo[situacao].nfces.add(chaveNfce);
            mapPeriodo[situacao].quantidade += 1;
            mapPeriodo[situacao].valorTotal += (cupom.valorTotalNota || cupom.valorTotal || 0);
          }
        });

        let arrayTotalPeriodo: any[] = [];
        arrayTotalPeriodo.push(['Tipo', 'Situação', 'Modelo', 'Quant.', 'Valor Total']);

        // Autorizada primeiro
        if (mapPeriodo['Autorizada']) {
          arrayTotalPeriodo.push([
            'NFC-e',
            'Autorizada',
            '65 (NFC-e)',
            mapPeriodo['Autorizada'].quantidade,
            'R$ ' + formatarValor(mapPeriodo['Autorizada'].valorTotal)
          ]);
        }
        if (mapPeriodo['Cancelada']) {
          arrayTotalPeriodo.push([
            'NFC-e',
            'Cancelada',
            '65 (NFC-e)',
            mapPeriodo['Cancelada'].quantidade,
            'R$ ' + formatarValor(mapPeriodo['Cancelada'].valorTotal)
          ]);
        }

        setStateTotalPeriodo(arrayTotalPeriodo);

        // CSV data
        const csvData = [
          ['Cupons Emitidos (Autorizados/Cancelados NFC-e)'],
          ...arrayCupons,
          [],
          ['Total Geral por CFOP'],
          ...arrayTotalCfop,
          [],
          ['Total do Período'],
          ...arrayTotalPeriodo
        ];
        setStateCsvData(csvData);

        if (exportFunction) {
          exportFunction(arrayCupons, arrayTotalCfop, arrayTotalPeriodo);
        }
      } else {
        setStateCupons([]);
        setStateTotalCfop([]);
        setStateTotalPeriodo([]);
      }
    } catch (error: any) {
      console.error('Erro ao carregar relatório fiscal:', error);
      setTextToast("Erro ao carregar relatório fiscal.");
      setShowToast(true);
      setStateCupons([]);
      setStateTotalCfop([]);
      setStateTotalPeriodo([]);
    }

    setShowLoading(false);
  }

  async function gerarRelatorioPDF(arrayCupons: any, arrayTotalCfop: any, arrayTotalPeriodo: any) {
    (pdfMake as any).vfs = pdfFonts;

    const reportTitle: any = [{
      text: 'Relatório Fiscal - NFC-e',
      fontSize: 15,
      bold: true,
      margin: [15, 20, 0, 45]
    }];

    const reportDetails: any = [
      { text: lojaSelecionadaNome, style: 'subheader' },
      { text: 'Data início: ' + new Date(dataAgendamentoPeriodo1 || "").toLocaleString("pt-BR").substring(0, 10), style: 'subheader' },
      { text: 'Data fim: ' + new Date(dataAgendamentoPeriodo2 || "").toLocaleString("pt-BR").substring(0, 10), style: 'subheader' },
      { text: ' ', margin: [0, 5, 0, 5] },
      { text: 'Cupons Emitidos (NFC-e)', style: 'sectionTitle' },
      {
        table: {
          body: arrayCupons
        },
        layout: {
          fillColor: function (rowIndex: any) {
            return (rowIndex === 0) ? '#ff7000' : (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        },
        style: 'padrao'
      },
      { text: ' ', margin: [0, 10, 0, 10] },
      { text: 'Total Geral por CFOP', style: 'sectionTitle' },
      {
        table: {
          body: arrayTotalCfop
        },
        layout: {
          fillColor: function (rowIndex: any) {
            return (rowIndex === 0) ? '#ff7000' : (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        },
        style: 'padrao'
      },
      { text: ' ', margin: [0, 10, 0, 10] },
      { text: 'Total do Período', style: 'sectionTitle' },
      {
        table: {
          body: arrayTotalPeriodo
        },
        layout: {
          fillColor: function (rowIndex: any) {
            return (rowIndex === 0) ? '#ff7000' : (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        },
        style: 'padrao'
      }
    ];

    function rodape(currentPage: any, pageCount: any) {
      return [
        {
          text: currentPage + ' / ' + pageCount,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0]
        }
      ]
    }

    const docDefinitions: any = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargin: [15, 50, 15, 40],
      content: [reportDetails],
      footer: rodape,
      styles: {
        header: {
          fontSize: 10,
          bold: true
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        sectionTitle: {
          fontSize: 12,
          bold: true,
          margin: [0, 5, 0, 5]
        },
        padrao: {
          fontSize: 8
        }
      }
    }

    pdfMake.createPdf(docDefinitions).open();
  }

  const openPopoverInicio = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataInicio(true);
  };

  const openPopoverFim = (e: any) => {
    popover2.current!.event = e;
    setShowModalDataFim(true);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { setStateCupons([]); setStateTotalCfop([]); setStateTotalPeriodo([]); setStateCarregado(false); history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>
          <IonTitle slot="start">Relatório Fiscal</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="light">
        <div style={{ textAlign: "center" }} hidden={stateCarregado}>

          <IonItem>
            <IonLabel>Data início</IonLabel>
            <IonLabel style={{ "color": "#BDBDBD" }} slot="end" onClick={e => { openPopoverInicio(e); }}>{dataAgendamentoPeriodo1Br}</IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel>Data fim</IonLabel>
            <IonLabel style={{ "color": "#BDBDBD" }} slot="end" onClick={e => { openPopoverFim(e); }}>{dataAgendamentoPeriodo2Br}</IonLabel>
          </IonItem>

          <IonItem hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
            <IonLabel>Loja</IonLabel>
            <IonSelect name='Lojas' placeholder='Selecione as lojas' title='Lojas' value={lojaSelecionadaId} multiple={false} cancelText="Cancel" okText="Ok" onIonChange={e => {
              let found = JSON.parse(window.localStorage.getItem("lojas") || "[]").find((obj: any) => {
                return obj.empresaLojaId === e.detail.value;
              });
              if (found) {
                setLojaSelecionadaNome(found.empresaLojaNome);
              }
              setLojaSelecionadaId(e.detail.value);
            }} slot="end">
              {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                <IonSelectOption key={"lojaid" + valor.empresaLojaId} value={valor.empresaLojaId}>{valor.empresaLojaNome}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>

          <p></p>
          <IonButton onClick={async () => { await carregarDados() }} expand="block" type="submit" fill='solid' color='tertiary'>Buscar</IonButton>
        </div>
        <div style={{ textAlign: "center" }} hidden={!stateCarregado}>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>{lojaSelecionadaNome}</IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>Data início: {dayjs(dataAgendamentoPeriodo1).format("DD/MM/YYYY")}</IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel style={{ textAlign: 'center' }}>Data fim: {dayjs(dataAgendamentoPeriodo2).format("DD/MM/YYYY")}</IonLabel>
          </IonItem>

          <p></p>
          <IonButton onClick={() => { setStateCupons([]); setStateTotalCfop([]); setStateTotalPeriodo([]); setStateCarregado(false); }} type="button" fill='solid' color='tertiary'>Limpar</IonButton>
          <IonButton hidden={isPlatform("android") || isPlatform("ios")} onClick={() => gerarRelatorioPDF(stateCupons, stateTotalCfop, stateTotalPeriodo)} type="button" fill='solid' color='tertiary'>Gerar PDF</IonButton>
          <CSVLink hidden={isPlatform("android") || isPlatform("ios")} data={stateCsvData} separator={";"}><IonButton type="button" fill='solid' color='tertiary'>Gerar CSV</IonButton></CSVLink>

          <p></p>
          <FiscalTable cupons={stateCupons} totalPorCfop={stateTotalCfop} totalPorPeriodo={stateTotalPeriodo}></FiscalTable>
        </div>
        <p></p>

        <IonPopover ref={popover1}
          isOpen={showModalDataInicio}
          onDidDismiss={() => setShowModalDataInicio(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo1Br(dataFormatada);
                  setDataAgendamentoPeriodo1(data);
                }
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonPopover ref={popover2}
          isOpen={showModalDataFim}
          onDidDismiss={() => setShowModalDataFim(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAgendamentoPeriodo2Br(dataFormatada);
                  setDataAgendamentoPeriodo2(data);
                }
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>
    </IonPage>
  );
};

export default RelatorioFiscal;
